import { ScoringSettings } from '../../MFL_ScoringSetting.js'
const scoring=[
    "Passing Yards",
    "Number of Passing TDs",
    "Rushing Yards",
    "Number of Rushing TDs",
    "Receptions",
    "Receiving Yards",
    "Number of Receiving TDs",
    "Pass Interceptions Thrown"
]
const scoringPositions=[
    "QB",
    "RB",
    "WR",
    "TE"
]
export const parseRules= (rules) => {
    console.log("parsingRules")
    const dict={}
    scoringPositions.forEach(pos=>{dict[pos]=PositionRuleRender(pos,rules)})
    return dict
    }
    const getScoringCode= (desc) => {
        const temp=ScoringSettings.find(s=>s["shortDescription"]["$t"]===desc)
        console.log((temp["abbreviation"]["$t"]))
        return (temp["abbreviation"]["$t"])
    }
    const PositionStatRule= (pos,setting,rules) => {
        console.log('searching',pos,setting)
        if (!(rules instanceof Array)) {
            rules=[rules]
        }
        console.log('arry',rules.filter(r=>r.positions.split('|').includes(pos)))
        return(rules.filter(r=>r.positions.split('|').includes(pos))
        .map(r=>{console.log(r); 
            return ((Array.isArray(r["rule"])?
                (r["rule"].find(s=>s["event"]["$t"]===setting)||{"points":{"$t":'0'}}):
                ((r["rule"]["event"]&&r["rule"]["event"]["$t"]===setting)?r["rule"]:{"points":{"$t":'0'}})
                )["points"]["$t"])})
        .reduce((pv, cv) => pv + eval(cv.replace('*', '')), 0))
    }
    const PositionRuleRender= (pos,rules) => {
        const dict={}
        scoring.forEach(desc=> {dict[desc]=PositionStatRule(pos,getScoringCode(desc),rules)})
        return(dict)
    }